import get from 'lodash.get';
import { FocusEvent, useState } from 'react';
import {
  FORM_DATA,
  FORM_ERROR,
  FORM_VALIDATOR_RETURN_TYPE,
  VALIDATE_FORM,
} from './types';
import { getError, touchErrors } from './utils';

export const useFormValidator = (
  formValue: Record<string, FORM_DATA>
): FORM_VALIDATOR_RETURN_TYPE => {
  const [formData, setFormData] =
    useState<Record<string, FORM_DATA>>(formValue);

  const validateForm = ({
    form,
    field,
    forceTouchErrors = false,
  }: VALIDATE_FORM) => {
    const formObj = JSON.parse(JSON.stringify(form));

    let validateError;
    let isFormValid = true;

    validateError = getError(field, formObj);

    // Force validate all the fields
    if (forceTouchErrors) {
      const formKeys = Object.keys(formObj);
      formKeys.forEach((key) => {
        formObj[key].errors = touchErrors(formObj[key].errors);
        validateError = getError(key, formObj);

        if (validateError.isValid === false) {
          isFormValid = false;
        }
      });
    }

    setFormData(formObj);

    return {
      isValid: isFormValid,
      updatedFormErrors: validateError.updatedFormErrors,
    };
  };

  const onBlurField = (e: FocusEvent<HTMLInputElement>) => {
    const field = e.target?.name;

    const err = get(formData, [field, 'errors'], {}) as FORM_ERROR;
    if (err.touched) {
      return;
    }

    const updatedErrors = JSON.parse(JSON.stringify(formData));
    updatedErrors[field].errors.touched = true;

    validateForm({ form: updatedErrors, field });
  };

  return {
    validateForm,
    onBlurField,
    formData,
  };
};
